import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ae0cd7f8")

_pushScopeId("data-v-ae0cd7f8")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-center text-gray-200" }
const _hoisted_3 = { class: "pl-2 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_fa, {
                class: "animate-spin",
                icon: "spinner",
                type: "fas",
                height: "18"
              }),
              _createVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
              ])
            ])
          ]),
          _: 3
        })
      ]))
    : _createCommentVNode("", true)
})